module.exports = __webpack_public_path__ + "static/media/user-protection-error.b95e67b2.svg";